<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    :title="tag.label ? `edit tag ${tag.label}` : 'create new tag'"
    :submit-name="tag.label ? 'edit' : 'create'"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <lm-input
      ref="inputLabel"
      class="py-8 pr-8"
      :label="
        tag.label ? `enter new label for tag '${tag.label}'` : 'enter new tag'
      "
      @submit="submitFromInput"
    />
  </form-modal>
</template>
<script>
import {mapGetters} from 'vuex'
import LmInput from '@/components/form/LmInput'
import FormModal from '@/components/modals/FormModal'
import EventHub from '@/lib/eventHub'
import {Events, Modal} from '@/lib/definitions'
import FormHelper from '@/components/form/formHelper'

export default {
  name: Modal.UPSERT_TAG,
  components: {
    FormModal,
    LmInput
  },
  data() {
    return {
      Events,
      inputs: null,
      modalName: Modal.UPSERT_TAG
    }
  },
  computed: {
    ...mapGetters({tag: 'tags/inEdit'})
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.inputLabel]
    this.$refs.inputLabel.data = this.tag.label
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        this.$store
          .dispatch('upsertTag', {
            label: this.$refs.inputLabel.data,
            slug: this.tag.slug
          })
          .then(() => this.modalRef.submitSuccess())
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        const op = this.tag.slug ? 'edited' : 'created'
        EventHub.emit(
          Events.SHOW_SNACKBAR,
          `Tag ${this.$refs.inputLabel.data} succesfully ${op}`
        )
      }
    }
  }
}
</script>
